// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CQmM","colMin":"styles_colMin__oWSad"};